<div class="language-mismatch-notification">
  <div class="notification-dt">
    <div class="notification-left-container">
      <img src="assets/icons/warning/warning-red-24px.svg" alt="Icon/Warning/Red">
    </div>
    <p class="notification-info">
      <strong>Language mismatch detected:</strong> The detected language is <strong>{{ detectedLanguage }}</strong>, which doesn't
      match the selected source language. Please select the correct source language to proceed.
    </p>
  </div>
</div>
